import { UI } from "components";

export default function Terms(){
    return(
    <>
    <UI.Header title="Termos de Utilização do Consultor Bonífica" />

    <UI.Terms maxH={null} />
    </>
    )
}